// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","775":"component---src-templates-essay-detail-js","883":"component---src-pages-404-js","928":"component---src-templates-work-detail-js"}[chunkId] + "-" + {"532":"04e177972bb06b59a83b","775":"5ebfb0f4207b6c393965","883":"baf43c0966df5dd14ce9","928":"5d5bcf39782fe3ae048f"}[chunkId] + ".js";
};